import React from 'react';
import FloorPlanImgProps from './FloorPlanImg.props';
import ImageZoomInOut from '../ImageZoomInOut/ImageZoomInOut';
import styles from './floorPlanImg.module.scss';

const FloorPlanImg = (props: FloorPlanImgProps) => {
  const floorPlanImage = props.floorPlanImg;

  return (
    <section className={styles.floorPlanImg}>
      {floorPlanImage && <ImageZoomInOut imageUrl={floorPlanImage} />}
    </section>
  );
};

export default FloorPlanImg;
